import { platformContextService } from '../platformContext/PlatformContextService';
import { PlatformEnum } from '../platformContext/platformContextTypes';

export function getDevice() {
  const { platform } = platformContextService.getConfig();
  if (platform === PlatformEnum.APP_ANDROID || platform === PlatformEnum.APP_IOS) {
    return 'Mobile';
  }
  if (navigator.maxTouchPoints > 0) {
    return 'Web Mobile';
  }
  return 'Web Desktop';
}

export function getScreenSize(): `${number}x${number}` {
  return `${window?.screen.availWidth}x${window?.screen.availHeight}`;
}

/*
 https://docs.google.com/spreadsheets/d/1mGVr8ApD_0UEYPsmIOgQ5Qelr51fmjVeM6EBViX-A6w/edit#gid=131408382
 Required params
 ✔️"device",
 ✔️"user_id",
 ✔️"screen_size",
 Autogenerated params
 ✔️"referrer",
 */
